/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
(function () {
  'use strict';

  var processed = new WeakSet();

  function fixDetailsSummaryLink(details) {
    if (processed.has(details)) return;

    var summary = details.querySelector(':scope > summary');
    if (!summary) return;

    var nestedLink = summary.querySelector(':scope > a');
    if (!nestedLink) return;

    processed.add(details);

    // Preserve the link exactly as-is (href, classes, aria-current, text)
    var newLink = nestedLink.cloneNode(true);

    // Remove the <a> from inside <summary> — summary becomes a pure toggle
    nestedLink.remove();

    // Give the now-textless summary an accessible name
    var linkTitle = newLink.textContent.trim();
    summary.setAttribute('aria-label', 'Show ' + linkTitle + ' submenu');
    summary.classList.add('primary-nav__summary-toggle');

    // Insert the link as a sibling before <details>, keep <details> intact
    var parent = details.parentElement;
    if (parent) {
      parent.classList.add('primary-nav__item--split');
      parent.insertBefore(newLink, details);
    }
  }

  function scan(root) {
    root.querySelectorAll('details').forEach(fixDetailsSummaryLink);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'DETAILS') {
            fixDetailsSummaryLink(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
(function () {
  'use strict';

  var processed = new WeakSet();

  function skipLinkFromKeyboard(item) {
    if (processed.has(item)) return;

    var link = item.querySelector(':scope > a');
    if (!link) return;

    processed.add(item);

    link.setAttribute('tabindex', '-1');
    link.setAttribute('aria-hidden', 'true');
  }

  function scan(root) {
    root.querySelectorAll('.primary-nav__item--split').forEach(skipLinkFromKeyboard);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('primary-nav__item--split')) {
            skipLinkFromKeyboard(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//product card
(function () {
  'use strict';

  var BROKEN_PATTERN = /^\s*product-card-link[\s\S]*href\s*=\s*"[^"]*"[\s\S]*?(?:&gt;|>)\s*$/;

  function parseAttrs(text) {
    var attrs = {};
    var attrRegex = /([a-zA-Z-]+)\s*=\s*"([^"]*)"/g;
    var match;
    while ((match = attrRegex.exec(text)) !== null) {
      attrs[match[1]] = match[2];
    }
    return attrs;
  }

  function repairBrokenAnchor(textNode) {
    var text = textNode.textContent;
    if (!BROKEN_PATTERN.test(text)) return false;

    var attrs = parseAttrs(text);
    if (!attrs.href) return false;

    var parent = textNode.parentNode;
    if (!parent) return false;

    // The element that used to be *inside* the <a> now sits as the
    // next sibling, unwrapped. Grab it (and any siblings up to the
    // next element that clearly isn't part of this link, e.g. a
    // sibling <button> that was never inside the <a> to begin with).
    var contentNode = textNode.nextElementSibling;
    if (!contentNode) return false;

    var newLink = document.createElement('a');
    newLink.setAttribute('product-card-link', '');
    Object.keys(attrs).forEach(function (key) {
      newLink.setAttribute(key, attrs[key]);
    });

    parent.insertBefore(newLink, textNode);
    newLink.appendChild(contentNode);
    textNode.remove();

    return true;
  }

  function scanForBrokenLinks(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return BROKEN_PATTERN.test(node.textContent)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    });

    var broken = [];
    var node;
    while ((node = walker.nextNode())) {
      broken.push(node);
    }
    broken.forEach(repairBrokenAnchor);
  }

  function init() {
    scanForBrokenLinks(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            scanForBrokenLinks(node);
          } else if (node.nodeType === 3 && BROKEN_PATTERN.test(node.textContent)) {
            repairBrokenAnchor(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
(function () {
  'use strict';

  var SWATCH_SELECTOR = 'product-card-variant-swatch';
  var LIST_SELECTOR = '.product-card__swatch__items';
  var ACTIVE_CLASS = 'is-active';

  var processedLists = new WeakSet();
  var processedSwatches = new WeakSet();

  function setChecked(swatch, isActive) {
    swatch.setAttribute('aria-checked', isActive ? 'true' : 'false');
  }

  function getSwatchesInList(list) {
    return Array.prototype.slice.call(list.querySelectorAll(SWATCH_SELECTOR));
  }

  function focusSwatch(swatch) {
    swatch.setAttribute('tabindex', '0');
    swatch.focus();
  }

  function selectSwatch(swatch, list) {
    getSwatchesInList(list).forEach(function (s) {
      setChecked(s, s === swatch);
    });
    swatch.click();
  }

  function handleKeydown(event, list) {
    var swatches = getSwatchesInList(list);
    var currentIndex = swatches.indexOf(event.target);
    if (currentIndex === -1) return;

    var key = event.key;

    if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      event.preventDefault();
      selectSwatch(event.target, list);
      return;
    }

    var nextIndex = null;
    if (key === 'ArrowRight' || key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % swatches.length;
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + swatches.length) % swatches.length;
    } else if (key === 'Home') {
      nextIndex = 0;
    } else if (key === 'End') {
      nextIndex = swatches.length - 1;
    }

    if (nextIndex !== null) {
      event.preventDefault();
      swatches.forEach(function (s) {
        s.setAttribute('tabindex', s === swatches[nextIndex] ? '0' : '-1');
      });
      focusSwatch(swatches[nextIndex]);
      selectSwatch(swatches[nextIndex], list);
    }
  }

  function setupSwatch(swatch) {
    if (processedSwatches.has(swatch)) return;
    processedSwatches.add(swatch);

    swatch.setAttribute('role', 'radio');
    // aria-label is set server-side in Liquid (Color: X, Product Name)
    // and must NOT be touched or removed here
    var isActive = swatch.classList.contains(ACTIVE_CLASS);
    setChecked(swatch, isActive);
  }

  function setupListItems(list) {
    // <li> wrappers are purely structural once the <ul> is a radiogroup;
    // pull them out of the accessibility tree so they don't get flagged
    // as orphaned listitems (list role requires a role="list" parent)
    var items = list.querySelectorAll(':scope > li');
    items.forEach(function (li) {
      if (!li.hasAttribute('role')) {
        li.setAttribute('role', 'presentation');
      }
    });
  }

  function setupList(list) {
    if (processedLists.has(list)) return;
    processedLists.add(list);

    list.setAttribute('role', 'radiogroup');
    if (!list.hasAttribute('aria-label')) {
      list.setAttribute('aria-label', 'Color');
    }

    setupListItems(list);

    var swatches = getSwatchesInList(list);
    var hasActive = swatches.some(function (s) {
      return s.classList.contains(ACTIVE_CLASS);
    });

    swatches.forEach(function (swatch, index) {
      setupSwatch(swatch);
      var isActive = swatch.classList.contains(ACTIVE_CLASS);
      var isFirst = index === 0 && !hasActive;
      swatch.setAttribute('tabindex', isActive || isFirst ? '0' : '-1');
    });

    list.addEventListener('keydown', function (event) {
      handleKeydown(event, list);
    });
  }

  function scan(root) {
    root.querySelectorAll(LIST_SELECTOR).forEach(setupList);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(LIST_SELECTOR)) {
            setupList(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
//h1
(function () {
  function addHiddenH1FromTitle() {
    // ── 1. Check if page already has an h1 ──────────────────────
    const existingH1 = document.querySelector('h1');
    if (existingH1) return; // h1 exists — do nothing

    // ── 2. Get text from <title>, strip site name after separator ─
    const rawTitle = document.title || '';
    const pageTitle = rawTitle
      .split(/[|\-–—]/)  // split on | - – —
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; })[0] || rawTitle.trim();

    if (!pageTitle) return; // no title text found — bail

    // ── 3. Create visually hidden h1 ────────────────────────────
    const h1 = document.createElement('h1');
    h1.textContent = pageTitle;

    // Visually hidden but fully accessible to screen readers
    h1.style.cssText = [
      'position: absolute',
      'width: 1px',
      'height: 1px',
      'padding: 0',
      'margin: -1px',
      'overflow: hidden',
      'clip: rect(0, 0, 0, 0)',
      'white-space: nowrap',
      'border: 0'
    ].join('; ');

    // ── 4. Inject as first element inside <main> or <body> ───────
    const target = document.querySelector('main') ||
                   document.querySelector('[role="main"]') ||
                   document.body;

    target.insertBefore(h1, target.firstChild);
  }

  // ── Run on DOM ready ─────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHiddenH1FromTitle);
  } else {
    addHiddenH1FromTitle();
  }

})();
//alt

